import { Divider, Stack, Typography } from '@mui/material';
import React from 'react';

interface Props {
  title: string;
}

export const ViewTreatmentConsultationItem: React.FC<Props> = ({
  children,
  title,
}) => {
  if (!children) {
    return null;
  }

  return (
    <Stack spacing={2}>
      <Typography color="#000" fontWeight={400} fontSize={18}>
        {title}
      </Typography>
      <Divider />
      <Typography color="#000" fontWeight={400} fontSize={14}>
        {children}
      </Typography>
    </Stack>
  );
};
